<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <!-- Filter Section Start-->
        <div class="md-layout">
          <!-- Search Term Input -->
          <div class="md-layout-item md-small-size-100 md-size-0">
            <md-field>
              <label for="mtype">Search Term</label>
              <md-input
                name="term"
                id="term"
                v-model="transactionQuery.term"
                @md-selected="targetField('term', $event)"
              ></md-input>
              <!-- <md-icon>search</md-icon> -->
            </md-field>
          </div>
          <!-- Vertical Type -->
          <div class="md-layout-item md-small-size-100 md-size-15">
            <md-field>
              <label for="mtype">Vertical Type</label>
              <md-select
                name="method"
                id="method"
                @md-selected="targetField('vertical_type', $event)"
              >
                <md-option :value="''">ALL</md-option>
                <md-option v-for="(v, i) in verticals" :value="v" :key="i">{{
                  v.toUpperCase()
                }}</md-option>
              </md-select>
            </md-field>
          </div>
          <!-- Status -->
          <div class="md-layout-item md-small-size-100 md-size-15">
            <md-field>
              <label for="mtype">Status</label>
              <md-select
                name="vendStatus"
                id="vendStatus"
                @md-selected="targetField('vend_status', $event)"
              >
                <md-option :value="''">ALL</md-option>

                <md-option v-for="(v, i) in vendStatus" :value="v" :key="i">{{
                  v.toUpperCase()
                }}</md-option>
              </md-select>
            </md-field>
          </div>
          <!-- Servive Provider -->
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label for="mtype">Service Provider</label>
              <md-select
                class="dropdown"
                name="provider"
                id="provider"
                @md-selected="targetField('disco_code', $event)"
              >
                <!-- <md-optgroup label="None"> -->
                <md-option style="padding-left: 18px" :value="''"
                  >ALL</md-option
                >
                <!-- </md-optgroup> -->
                <md-optgroup label="ELECTRICITY">
                  <md-option
                    style="padding-left: 18px"
                    v-for="(d, i) in discos"
                    :value="d"
                    :key="i"
                    >{{ d.toUpperCase() }}</md-option
                  >
                </md-optgroup>
                <md-optgroup label="TV">
                  <md-option
                    style="padding-left: 18px"
                    v-for="(d, i) in providers"
                    :value="d"
                    :key="i"
                    >{{ d.toUpperCase() }}</md-option
                  >
                </md-optgroup>
              </md-select>
            </md-field>
          </div>
          <!-- Vend Type -->
          <div class="md-layout-item md-small-size-100 md-size-25">
            <md-field>
              <label for="mtype">Vend Type</label>
              <md-select
                name="vendType"
                id="vendType"
                @md-selected="targetField('vend_type', $event)"
              >
                <md-option :value="''">ALL</md-option>
                <md-option v-for="(v, i) in vendTypes" :value="v" :key="i">{{
                  v.toUpperCase()
                }}</md-option>
              </md-select>
            </md-field>
          </div>
          <!-- Payment Method -->
          <div class="md-layout-item md-small-size-100 md-size-15">
            <md-field>
              <label for="mtype">Payment Method</label>
              <md-select
                name="payment"
                id="payment"
                @md-selected="targetField('method', $event)"
              >
                <md-option :value="''">ALL</md-option>
                <md-option v-for="(v, i) in payment" :value="v.value" :key="i">{{
                  v.name.toUpperCase()
                }}</md-option>
              </md-select>
            </md-field>
          </div>
          <!-- Dropdown Filter -->
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Date</label>
              <md-select v-model="dateFilter">
                <md-option value="ALL">All Time</md-option>
                <md-option value="DAY">Last 24 Hours</md-option>

                <md-option value="MONTH">Last 30 Days</md-option>
                <md-option value="YEAR">Last 12 Months</md-option>
                <md-option value="CUSTOM">Custom</md-option>
              </md-select>
            </md-field>
          </div>
          <!-- Date From -->
          <div
            class="md-layout-item md-small-size-100 md-size-20"
            v-if="showDatePicker"
          >
            <md-datepicker md-immediately v-model="transactionQuery.start">
              <label>Date From</label>
            </md-datepicker>
          </div>

          <!-- Date To -->
          <div
            class="md-layout-item md-small-size-100 md-size-20"
            v-if="showDatePicker"
          >
            <md-datepicker md-immediately v-model="transactionQuery.end">
              <label>Date To</label>
            </md-datepicker>
          </div>
        </div>
        <!-- Filter Section End -->

        <!-- Filter Section: Action Buttons -->
        <div>
          <md-button class="md-raised md-success" @click="filterTransactions()"
            >Filter</md-button
          >

          <md-button class="md-raised md-danger" @click="resetQuery()"
            >Reset</md-button
          >
        </div>
        <!-- Filter Section: Action Buttons End -->

        <!-- <FilterOrders @reset="resetQuery" @filter="filterTransactions"/> -->

        <!-- Table -->
        <md-card>
          <md-card-content>
            <div class="text-right">
              <div>
                <md-button class="md-raised md-primary" @click="exportToExcel()">
                  <span v-if="isExportingData" class="spinner"></span>
                  {{ isExportingData ? 'VIEW EXPORT PROGRESS' : 'EXPORT TO EXCEL' }}
                </md-button>
              </div>
            </div>
            <div>
              <div>
                 <md-table table-header-color="green" >
                  <!-- Table Row -->
                  <md-table-row>
                    <md-table-head>S/N</md-table-head>
                    <md-table-head>Date</md-table-head>
                    <md-table-head>Customer Ref.</md-table-head>
                    <md-table-head>Vertical Type</md-table-head>
                    <md-table-head>Disco</md-table-head>
                    <md-table-head>Value</md-table-head>
                    <md-table-head>Type</md-table-head>
                    <md-table-head>Amount (&#8358;)</md-table-head>
                    <md-table-head>Order ID</md-table-head>
                    <md-table-head>Status</md-table-head>
                  </md-table-row>
                  <!-- Empty Data -->
                  <md-table-row v-if="transactions.length < 1">
                    <md-table-cell colspan="9">
                      <p>No record found.</p>
                    </md-table-cell>
                  </md-table-row>

                  <md-table-row
                    v-for="(transaction, index) in transactions"
                    :key="index"
                    @click="openOrderModal(transaction.id)"
                  >
                    <md-table-cell>{{ index + 1 }}</md-table-cell>
                    <md-table-cell md-label="Date">
                      {{ format(transaction.created_at, 'DD/MM/YYYY hh:mm a') }}
                    </md-table-cell>
                    <md-table-cell md-label="Meter/ Account Number">
                      {{ transaction.meter_no }}
                    </md-table-cell>
                    <md-table-cell md-label="Vertical Type">
                      {{
                        transaction.verticalType || transaction.vertical_type
                      }}
                    </md-table-cell>
                    <md-table-cell md-label="Disco">
                      {{ transaction.disco_code }}
                    </md-table-cell>
                    <md-table-cell
                      md-label="Value"
                    >
                      {{ getTransactionValue(transaction) }}
                      <!-- {{ formatToken(transaction.vendResponse ?
                      transaction.vendResponse.token : null) || 'No Value' }} -->
                    </md-table-cell>
                    <md-table-cell md-label="Type">
                      {{ transaction.vend_type }}
                    </md-table-cell>
                    <md-table-cell md-label="Amount">
                      {{ formatAmount(transaction.amount) }}
                    </md-table-cell>
                    <md-table-cell md-label="Order ID">
                      {{ transaction.order_id }}
                    </md-table-cell>
                    <md-table-cell md-label="Status">
                      {{ transaction.order_status }}
                    </md-table-cell>
                  </md-table-row>
                </md-table>
                <br />
                <div class="md-center" v-if="transactions.length > 28">
                  <md-button class="md-primary" @click="loadMore()"
                    >Load More</md-button
                  >
                </div>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>

    <OrderModal
      :current="current"
      ref="orderModal"
      :loading="loading"
      :isRequerying="isRequerying"
      @reQuery="reQuery"
    />

    <!-- Snack bar for error messages -->
    <md-snackbar
      md-position="center"
      :md-duration="6000"
      :md-active.sync="snackBar.show"
      md-persistent
    >
      <span>{{ snackBar.message }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import { format } from 'date-fns';
import moment from 'moment';
// import FilterOrders from './FilterOrders.vue';
import OrderModal from './OrderModal.vue';
// import { LoadingAnimation } from '../components'
import {
  commaNumber,
  formatAmount,
  formatToken,
} from '../../utils/Formatter.util';
import http from '../../utils/Http.util';

export default {
  components: {
    // LoadingAnimation,
    OrderModal,
    // FilterOrders,
  },
  watch: {
    dateFilter(view) {
      let from = new Date();
      let to = new Date();

      switch (view) {
        default:
          from = null;
          to = null;
          this.showDatePicker = false;
          break;
        case 'DAY':
          from = moment(from)
            .subtract(1, 'day')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        case 'MONTH':
          from = moment(from)
            .subtract(1, 'month')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        case 'YEAR':
          from = moment(from)
            .subtract(1, 'year')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        case 'CUSTOM':
          this.showDatePicker = true;
          return;
      }
      this.transactionQuery.start = from;
      this.transactionQuery.end = to;
    },
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
    isLive() {
      return this.$store.state.isLive;
    },
  },
  data() {
    return {
      selected: {},
      isExportingData: false,
      testDate: format(new Date(), 'YYYY-MM-DD'),
      dateFilter: 'DAY',
      showDatePicker: false,
      summary: {
        wallet: 0,
        transactions: {
          sum: 0,
          count: 0,
        },
        commission: 0,
      },
      dialog: {
        active: false,
        id: null,
        transactionDetail: { vendResponse: {} },
      },
      snackBar: {
        show: false,
        message: null,
      },
      discos: [
        'ABUJA',
        'KADUNA',
        'KANO',
        'JOS',
        'ENUGU',
        'PH',
        'EKO',
        'IKEJA',
        'IBADAN',
      ],
      verticals: ['tv', 'electricity', 'data', 'vtu'],
      payment: [{ name: 'BANK TRANSFER', value: 'BANK_TRANSFER' }, { name: 'APIX', value: 'APIX' }, { name: 'CARD', value: 'CARD' }, { name: 'DIRECT DEBIT', value: 'DIRECT_DEBIT' }, { name: 'INSTANT TRANSFER', value: 'INSTANT_TRANSFER' }, { name: 'WALLET', value: 'WALLET' }],
      vendStatus: ['SUCCESS', 'FAILED', 'PENDING', 'CANCELLED'],
      transactions: [],
      transactionQuery: {
        order_id: '',
        merchant_id: '',
        page: 1,
        limit: 30,
        start: null,
        end: null,
        filteredQuery: {},
        // start: format(new Date(), "YYYY-MM-DD"),
        // end: format(new Date(), "YYYY-MM-DD"),
        meterNo: '',
        checkpoint: null,
        order: JSON.stringify([['created_at', 'DESC']]),
        get created_at() {
          if (this.start && this.end) {
            this.end.setHours(23);
            this.end.setMinutes(59);
            this.end.setSeconds(59);

            return {
              $between: [this.start.toString(), this.end.toString()],
            };
          }

          return { $between: [this.start, this.end] };
        },
      },
      current: null,
      filterQuery: {},
      totalPages: 1,
      GTBANK_ID: '1253797',
      providers: ['dstv', 'gotv'],
      vendTypes: ['prepaid', 'postpaid'],
      loading: false,
      isRequerying: false,
    };
  },
  methods: {
    setIsExportingData(val) {
      this.isExportingData = val;
    },
    getTransactionValue(transaction) {
      const vendType = transaction.vend_type
      || (transaction.vendResponse && transaction.vendResponse.vend_type);
      let value;

      if (vendType === 'POSTPAID') {
        const debtPaymentType = transaction.vendResponse
          ? this.getDebtPaymentType(transaction.vendResponse) : undefined;
        switch (debtPaymentType) {
          case 'FULL_DEBT_REPAYMENT':
            value = 'Full Debt Repayment';
            break;
          default:
            value = transaction.vendResponse ? `${transaction.vendResponse.rct_num} (Receipt No.)` : undefined;
        }
      } else if (vendType === 'PREPAID') {
        if (transaction.vendResponse) {
          if (transaction.vendResponse.debt && transaction.vendResponse.debt > 0) {
            const debtPaymentType = this.getDebtPaymentType(transaction.vendResponse);
            if (debtPaymentType === 'FULL_DEBT_REPAYMENT') {
              value = 'Full Debt Repayment';
            } else {
              value = `${transaction.vendResponse.rct_num} (Receipt No.)`;
            }
          } else {
            value = transaction.vendResponse.token;
          }
        } else {
          value = undefined;
        }
      }

      if (value === undefined) {
        value = 'No Value';
      }

      return value;
    },

    getDebtPaymentType(vendResponse) {
      if (vendResponse && vendResponse.amt === vendResponse.debt) {
        return 'FULL_DEBT_REPAYMENT';
      }
      return 'OTHER';
    },

    async loadView(view) {
      // Pick date from state
      let from = new Date();
      let to = new Date();

      switch (view) {
        default:
          from = null;
          to = null;
          this.showDatePicker = false;
          break;
        case 'DAY':
          from = moment(from)
            .subtract(1, 'day')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        case 'MONTH':
          from = moment(from)
            .subtract(1, 'month')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        case 'YEAR':
          from = moment(from)
            .subtract(1, 'year')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        case 'CUSTOM':
          this.showDatePicker = true;
          return;
      }

      this.transactionQuery.start = from;
      this.transactionQuery.end = to;

      await this.filterTransactions();
    },
    openOrderModal(id) {
      this.$refs.orderModal.onOpen(id);
      this.getOrder(id);
    },
    commaNumber,
    formatAmount,
    formatToken,
    format,
    async reQuery(order) {
      const { order_id: orderId, id } = order;
      try {
        this.isRequerying = true;
        const { message } = await http.authReq(
          `/dashboard/orders/${orderId}/response`,
        );
        this.snackBar = {
          show: true,
          message,
        };
      } catch (error) {
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
      }

      // update data on modal
      await this.getSingleOrder(id);

      this.isRequerying = false;
    },

    async getSingleOrder(id) {
      try {
        const res = await http.authReq(`/dashboard/orders/${id}`);
        this.current = res.data;
        return res.data;
      } catch (error) {
        return {};
      }
    },

    clearDisco() {
      this.transactionQuery.discoCode = '';
    },
    setMerchantId(id) {
      this.transactionQuery.merchantId = id;
      this.getTransactions();
    },
    async getTransactions() {
      this.$store.commit('busyStatus', true);
      try {
        this.$store.commit('setTransactionQuery', this.transactionQuery);
        // TODO: the clearDisco method returns false as a string, this ensures its falsy
        if (!this.discos.includes(this.transactionQuery.discoCode)) { this.transactionQuery.discoCode = ''; }
        if (this.transactionQuery.phone && this.transactionQuery.merchantId) {
          this.transactionQuery.merchantId = '';
          this.$router.replace({
            ...this.$router.currentRoute,
            query: {},
          });
        }
        const { data } = await http.authReq('/dashboard/orders');
        this.transactionQuery.checkpoint = data.length > 0 ? data[0].created_at : null;
        this.transactions = data;
        this.$store.commit('setTransactions', data);
        // if (link) {
        //   formatExcelToDownloadLink(link);
        // }
      } catch (error) {
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
      }
      this.$store.commit('busyStatus', false);
    },
    async exportToExcel() {
      const startMoment = moment(this.transactionQuery.start);

      const startDate = (this.dateFilter !== 'CUSTOM'
        ? startMoment
        : startMoment.startOf('day')
      ).format('YYYY-MM-DD HH:mm:ss');

      const endMoment = moment(this.transactionQuery.end);

      const endDate = (this.dateFilter !== 'CUSTOM'
        ? endMoment
        : endMoment.endOf('day')
      ).format('YYYY-MM-DD HH:mm:ss');

      const params = new URLSearchParams({
        report_type: 'order',
        startDate,
        endDate,
      });
      try {
        const res = await http.authReq(`/dashboard/reports?${params.toString()}`, null, 'post');
        this.snackBar = {
          show: true,
          message: res.message,
        };
      } catch (err) {
        this.snackBar = {
          show: true,
          message: err.response ? err.response.data.message : err.message,
        };
      }
    },
    openModal(id) {
      this.dialog.active = true;
      this.loading = true;

      this.getOrder(id)
        .then((order) => {
          this.current = order;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async loadMore() {
      this.$store.commit('busyStatus', true);

      const {
        order,
        checkpoint,
        limit,
        page,
        filteredQuery,
      } = this.transactionQuery;

      const nextPage = page + 1;

      try {
        const { data } = await http.authReq(
          `/dashboard/orders?checkpoint=${checkpoint}&limit=${limit}&page=${nextPage}&order=${order}`,
          {
            where: filteredQuery,
          },
        );

        if (data.length <= 0) {
          this.snackBar = {
            show: true,
            message: 'Nothing more to load.',
          };
        } else {
          this.transactions = [...this.transactions, ...data];

          this.transactionQuery.page = nextPage;

          this.$store.commit('setTransactions', [...this.transactions, ...data]);
        }
      } catch (error) {
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
      }

      this.$store.commit('busyStatus', false);
    },

    async filterTransactions() {
      this.$store.commit('busyStatus', true);

      try {
        const { order, created_at, term } = this.transactionQuery;
        let query = created_at.$between[0] ? { created_at } : {};
        if (term) {
          query = {
            ...query,
            $or: [
              { order_id: term.trim() },
              { meter_no: term.trim() },
            ],
          };
        }

        if (Object.keys(this.filterQuery).length > 0) {
          query = {
            ...query,
            ...this.filterQuery,
          };
        }

        const jsonQuery = JSON.stringify(query);
        // const jsonQuery = stringifyDate.stringify(query);

        const { data } = await http.authReq(
          `/dashboard/orders?order=${order}`,
          {
            where: jsonQuery,
          },
        );

        this.transactionQuery.checkpoint = data.length > 0 ? data[0].created_at : null;
        this.transactionQuery.filteredQuery = jsonQuery;
        this.transactions = data;
        this.$store.commit('setTransactions', data);
      } catch (error) {
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
      } finally {
        this.$store.commit('busyStatus', false);
      }
    },
    targetField(field, data) {
      if (data) {
        this.filterQuery[field] = data;
      } else if (this.filterQuery[field]) {
        delete this.filterQuery[field];
      }
    },
    async resetQuery() {
      this.dateFilter = 'ALL';
      this.showDatePicker = false;
      await this.getTransactions();
      this.filterQuery = {};
      const fields = document.querySelectorAll('.md-input');
      for (let key = 0; key < fields.length; key += 1) {
        fields[key].value = '';
      }
    },
    closeModal() {
      this.dialog.active = false;
      this.current = null;
    },
    async getOrder(id) {
      this.loading = true;
      try {
        const res = await http.authReq(`/dashboard/orders/${id}`);
        this.current = res.data;
        this.loading = false;
        return res.data;
      } catch (error) {
        this.loading = false;
        return {};
      }
    },
  },
  mounted() {
    this.loadView('DAY');
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>
.md-table .md-table-row {
  cursor: pointer;
}
.md-datepicker {
  z-index: 1 !important;
}
.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.close {
  padding: 4px;
  // background: #a3a3a3;
  border-radius: 50%;
  font-size: 20px;
  font-weight: bold;
  &:hover {
    cursor: pointer;
  }
}
.table-body {
  // width: 100%;
  overflow-x: auto;
  scroll-behavior: auto;
  // max-width: 50%;
}

.md-dialog /deep/.md-dialog-container {
  max-width: 100%;
}
.dropdown {
  span {
    padding: 0 24px !important;
  }
}

.body {
  max-width: 100%;
}
</style>

<style lang="scss" scoped>
.page-btn {
  margin-right: 20px;
  font-size: 20px !important;
}
.dropdown-search {
  width: 90%;
  height: 30px;
  margin: 0 auto;
  margin-bottom: 5px;
  box-shadow: none;
}

.spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  margin-right: 8px;
  vertical-align: middle;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
